"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SberPay = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SberPay = function SberPay(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SberPay_svg__SberPay_svg__clip0_20336_109071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.655 29.054h20.72a9.527 9.527 0 100-19.054H9.656a9.527 9.527 0 000 19.054z",
    fill: "url(#SberPay_svg__SberPay_svg__paint0_linear_20336_109071)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.41 20.45v1.996h-1.15v-6.409h2.134c2.023 0 2.883.723 2.883 2.173 0 1.492-1.007 2.242-2.883 2.242l-.984-.002zm0-3.36v2.307h1.07c1.063 0 1.612-.348 1.612-1.218 0-.787-.477-1.089-1.593-1.089h-1.09zm4.476 1.1c.302-.23.852-.414 1.64-.414 1.337 0 1.996.458 1.996 1.649v3.021h-1.008v-.824c-.22.531-.779.894-1.51.894-.925 0-1.474-.522-1.474-1.42 0-1.044.759-1.336 1.886-1.336h1.038v-.198c0-.65-.31-.851-.924-.851-.844 0-1.328.33-1.64.815l-.004-1.337zm2.568 2.644v-.375h-.906c-.633 0-.934.12-.934.531 0 .348.255.568.732.568.724 0 1.058-.412 1.108-.724zm1.598-2.966h1.2l1.254 3.14 1.023-3.14h1.136l-1.83 5.064c-.402 1.099-.815 1.345-1.419 1.345-.284 0-.594-.081-.732-.2v-.998a.81.81 0 00.55.228c.329 0 .576-.22.75-.842l-1.932-4.597zm-20.268.325v1.406l1.864 1.17 4.462-3.29a4.847 4.847 0 00-.587-.973l-3.875 2.856-1.864-1.169z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.419 19.4v.1a3.768 3.768 0 11-1.648-3.11l.952-.702a4.897 4.897 0 101.744 2.933l-1.048.778z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SberPay_svg__SberPay_svg__paint0_linear_20336_109071",
    x1: 50.351,
    y1: 7.316,
    x2: 11.38,
    y2: 50.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#00ADED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#42E3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#00D900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#FAED00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SberPay_svg__SberPay_svg__clip0_20336_109071"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 10)",
    d: "M0 0h40v19.169H0z"
  }))));
};

exports.SberPay = SberPay;
var _default = SberPay;
exports.default = _default;